module.exports = "/_next/static/images/ac68fd5c3e8935ff9fbc8620f6ac9af2-slide-2.png";